


















import Vue from 'vue'
import SearchIcon from '@/components/icons/SearchIcon.vue'
import SpellListIcon from '@/components/icons/SpellListIcon.vue'
import SpellBookIcon from '@/components/icons/SpellBookIcon.vue'

export default Vue.extend({
  name: 'NavigationBar',
  components: {
    SearchIcon,
    SpellListIcon,
    SpellBookIcon,
  },
})
